import { render, staticRenderFns } from "./Commission_Type.vue?vue&type=template&id=74133b61&scoped=true&"
import script from "./Commission_Type.vue?vue&type=script&lang=js&"
export * from "./Commission_Type.vue?vue&type=script&lang=js&"
import style0 from "./Commission_Type.vue?vue&type=style&index=0&id=74133b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74133b61",
  null
  
)

export default component.exports